"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarLoader = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const placeholder_1 = __importDefault(require("../placeholder"));
const Placeholder = (0, styled_components_1.default)(placeholder_1.default) `
  box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.2);
`;
const AvatarLoader = ({ size }) => {
    return react_1.default.createElement(Placeholder, { size: size === "normal" ? 48 : 128, circle: true });
};
exports.AvatarLoader = AvatarLoader;
